<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { useFormValidate } from "@/hooks";

const props = defineProps<{
  buttonText?: string;
  formKeys: string[];
}>();

const emit = defineEmits(["click"]);

const { validate } = useFormValidate(props.formKeys);

async function onClick() {
  if (validate) {
    const isValid = await validate();
    if (!isValid) return;
  }

  emit("click");
}
</script>
<template>
  <nut-button class="mp-validate-button" v-bind="$attrs" @click.stop="onClick">
    <template #default v-if="$slots.default">
      <slot name="default" />
    </template>
    <template #default v-else-if="buttonText">
      {{ buttonText }}
    </template>
    <template #icon v-if="$slots.icon">
      <slot name="icon" />
    </template>
  </nut-button>
</template>
<style lang="scss">
.mp-validate-button.nut-button--square {
  &.nut-button--mini {
    border-radius: 6px !important;
  }

  &.nut-button--small {
    border-radius: 8px !important;
  }

  &.nut-button--normal {
    border-radius: 10px !important;
  }

  &.nut-button--large {
    border-radius: 12px !important;
  }
}
</style>
